import { Mfe, GlobalInfo } from '@nio-pow/mfe-vue3'
import envConfig from '@/utils/envConfig'
import Analytics from '@/core/Analytics'
import Navigator from '@/core/Navigator'
import { HeaderUtils, headerHeight } from '@/components/HeaderNav/HeaderUtils'
import { LayoutUtils } from '@/components/Layout/LayoutUtils'
import microAppLifeCycle from './microAppLifeCycle'
import originApps from './config'

export const initMfeConfig = () => {
  try {
    const { APP_ID, BASE_MICRO_APPS } = envConfig
    const { version } = require('../../package.json')

    GlobalInfo.set('appId', APP_ID)
    GlobalInfo.set('appVer', version)

    // 对一些主应用配置进行初始化
    Mfe.config.commonParams = { appId: APP_ID, appVer: version }
    Mfe.config.microAppHost = BASE_MICRO_APPS
    Mfe.config.containerSelector = '#microAppContainer'
    Mfe.config.microAppLifeCycle = microAppLifeCycle
    Mfe.config.originMicroApps = originApps
    Mfe.config.qiankunExcludeAssetHostList = [
      '/nodeplayer/',
      '/without-mfe-sandbox/',
      'googleapis.com',
      'qq.com',
      'map.gtimg.com',
      'bdimg.com', // 百度地图相关
      'baidu.com', // 百度地图相关
    ]
    Mfe.config.safeAreaTopOffset = headerHeight
    Mfe.config.qiankunRootPropsSdk = {
      Analytics,
      Navigator,
      HeaderUtils,
      LayoutUtils,
    }

    Mfe.config.apm = {
      aid: 485551128,
      token: 'dd0e87f81933496d97d213e5f7d4878b',
      // 这里不传 release，以便后续通过 getCurrentAppReleaseVersion 函数动态变更
      // release: 'pg@' + require('../../package.json').version,
    }
  } catch (error) {
    console.error('[MFE] 主应用初始化配置异常')
  }
}

initMfeConfig()

export default Mfe.startMfe
